var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.761963,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#5C61F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1787 10.4141H12.262C11.7758 10.4141 11.3095 10.6072 10.9657 10.951C10.6219 11.2949 10.4287 11.7612 10.4287 12.2474V20.4974C10.4287 20.9836 10.6219 21.4499 10.9657 21.7938C11.3095 22.1376 11.7758 22.3307 12.262 22.3307H20.512C20.9983 22.3307 21.4646 22.1376 21.8084 21.7938C22.1522 21.4499 22.3454 20.9836 22.3454 20.4974V19.5807",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 8.58343L24.1786 11.3334M25.4482 10.0363C25.8092 9.67532 26.0121 9.18567 26.0121 8.6751C26.0121 8.16453 25.8092 7.67487 25.4482 7.31385C25.0872 6.95282 24.5975 6.75 24.087 6.75C23.5764 6.75 23.0867 6.95282 22.7257 7.31385L15.012 15.0001V17.7501H17.762L25.4482 10.0363Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLearning);
export default __webpack_public_path__ + "static/media/editLearning.63b8b8ae1a873bf7ae612df35b297c2c.svg";
export { ForwardRef as ReactComponent };